var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlob = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 463,
  height: 463,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__a)",
  d: "M211.027 399.782c96.274 0 174.319-78.046 174.319-174.32s-78.045-174.32-174.319-174.32-174.32 78.046-174.32 174.32 78.046 174.32 174.32 174.32"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__b)",
  d: "M233.866 319.735c-.248 4.794-2.883 4.996-4.798 8.454-3.568 6.457.65 13.48-1.632 20.412-2.805 8.53-10.341 9.965-12.195 19.556-1.703 8.794.53 12.869-6.299 19.406-3.694 3.535-7.221 7.328-9.517 11.838a174 174 0 0 1-23.293-3.113c-.903-6.697-.236-13.682.48-20.471.774-7.345 2.492-19.158-.015-26.519-3.247-9.525-15.073-6.501-22.119-11.319-9.131-6.244-3.571-16.171-5.956-24.717-2.59-9.286-16.076-9.61-23.844-9.885-7.896.235-15.201-4.054-20.747-9.46-2.957-2.884-5.177-6.731-8.75-8.797-3.77-2.183-8.35-.987-12.131-2.61-7.042-3.018-10.792-8.77-10.872-16.22-.036-3.335-.337-6.917.734-10.076 1.139-3.359 4.359-5.327 4.645-8.936.2-2.488-1.867-16.317-4.156-17.504-7.566-3.927-4.906 12.207-8.236 13.928-5.158 2.667-11.13-11.43-11.958-15.754-1.336-7.009 1.564-15-1.029-21.671-1.487-3.824-4.676-4.354-6.157-7.896-1.587-3.797 1.81-8.378 1.127-12.106-.555-3.043-2.47-5.448-3.882-8.35 7.353-26 20.588-49.533 38.176-69.063 2.52 4.087 6.893 7.239 10.876 9.096 3.517 1.637 7.335 2.456 11.167 2.494 3.835.04 7.804-2.389 11.057-.973 5.613 2.448 6.506 11.55 4.586 16.201-3.418 8.273-8.304 7.892 1.68 11.865 4.392 1.749 12.36 7.764 17.463 7.531 6.105-.282 5.554-8.587 13.122-8.88 6.061-.233 10.666 3.757 16.27 5.55 6.52 2.088 14.301 1.553 20.122 5.645 6.231 4.381 6.936 24.856 3.855 32.245-3.175 7.617-10.743 5.331-14.896 1.819-3.653-3.092-10.836-14.33-13.315-4.348-1.968 7.917 7.322 9.529 8.389 15.849 1.256 7.446-7.299 7.545-12.371 8.646-8.252 1.795-6.095 7.845-12.671 12.551-2.494 1.78-6.095.901-7.821 4.563-1.288 2.738-.522 5.972-1.585 8.658-1.372 3.458-3.375 5.413-3.742 10.06-.212 2.723.857 6.313-.835 8.677-4.573 6.374-14.778-.851-19.478 7.025-2.881 4.829-.425 4.985.773 9.459.856 3.216-1.238 9.189 1.124 11.171 17.373 14.583 28.015-.93 31.892-2.765 8.163-3.864 17.983-8.025 27.104-6.568 8.4 1.342 11.003 9.834 19.823 9.948 8.275.105 15.186-.785 22.956 3.738 6.649 3.872 11.668 13.471 14.48 20.761 1.166 3.022 2.571 7.57 2.401 10.855z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__c)",
  d: "M313.703 84.575a55 55 0 0 1-2.043 3.163c-4.17 5.973-3.361 6.817-4.18 13.114-1.273 9.797-10.615 16.984-18.175 22.942-9.323 7.349-14.839 3.531-24.994 6.814-8.239 2.664-12.538 18.987-20.588 15.389-7.602-3.399-13.476-16.046-14.842-23.799-1.191-6.778-.536-15.952-5.579-21.54-5.52-6.12-15.923-2.893-21.117-10.868-3.622-5.56-.465-13.244-3.03-19.016-4.132-9.3-17.847-1.776-26.412-4.813-4.108-1.457-5.182-5.314-4.685-9.48 13.745-3.486 28.14-5.336 42.968-5.336 38.387 0 73.876 12.408 102.675 33.433z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__d)",
  d: "M385.347 225.462c0 58.393-28.712 110.082-72.79 141.716-1.974-2.888-4.034-5.543-4.434-9.578-.865-8.742 7.248-14.174 7.566-23.141.471-13.352 7.788-39.919-17.163-32.701 0 0-12.276-.029-17.203-.326-5.086-.307-10.855.076-15.546-2.976-7.551-4.91-13.101-15.037-15.763-24.8-2.119-7.764-3.113-11.96-.057-21.104 1.976-5.918 7.217-18.217 11.415-22.186 5.093-4.811 17.209-3.132 23.799-3.873 7.679-.865 14.767-1.507 22.053-5.251 3.841-1.976 7.246-5.322 11.367-6.385 3.613-.928 7.452.171 11.059-1.191 7.49-2.824 11.036-5.743 19.259-5.76 15.413-.034 15.243-24.228 30.629-27.22 3.789 14.29 5.807 29.299 5.807 44.78z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__e)",
  d: "M358.585 132.612c-6.459 4.249-15.11 5.501-22.763 2.319-5.28-2.197-6.547-10.262-10.564-14.917-4.997-5.792-8.821-8.027-5.723-16.323 1.253-3.35 3.081-6.966 5.165-10.388a175.1 175.1 0 0 1 33.887 39.309z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__f)",
  d: "M375.28 166.941c-2.28.804-4.597 1.399-6.752 2.666-2.454 1.444-4.266 3.744-6.821 5.022-5.349 2.685-8.485 1.484-11.442 7.014-1.36 2.543-2.913 12.156-6.73 12.325-3.225.143-3.892-10.098-4.91-12.563-2.338-5.652-3.54-5.339-9.039-1.818-5.428 3.477-7.806 7.101-9.187 13.231-1.022 4.54-.684 7.31-6.221 9.603-3.975 1.648-8.971 1.238-13.231 2.156-6.385 1.374-8.199 6.317-14.035 7.589-3.898.85-14.997.883-17.88-2.385-4.771-5.415-.478-19.052 4.133-23.194 6.166-5.537 17.811-6.935 22.605-13.164 5.055-6.568 7.389-16.832 10.56-24.04 3.378-7.682 15.585-11.123 24.053-7.688 4.239 1.719 6.108 4.139 11.171 4.733 6.158.722 17.811 1.454 23.99-1.74 3.742 7.138 7 14.569 9.736 22.249z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__g)",
  d: "M185.216 135.855c-6.278 1.517-7.596.155-9.869-5.283-.73-1.751-.025-4.428-1.027-6.101-1.214-2.031-4.726-3.184-6.395-4.781-4.329-4.146-5.161-5.175-11.243-7.713-2.431-1.015-10.419-2.507-12.669-4.397-5.817-4.882-2.877-15.157 1.946-22.358 2.135-3.187 5.775-5.072 9.608-4.906q.032 0 .061.002c4.514.21 4.558 1.78 7.45 3.171 3.115 1.499 6.574 1.951 10.125 2.36a11.07 11.07 0 0 1 9.748 9.91c.255 2.561.472 5.12.598 7.833.273 5.937 2.55 7.553 5.661 12.324 5.788 8.886 8.774 16.849-3.992 19.935z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__h)",
  d: "M176.421 262.738c-2.34 1.805-8.389-1.41-11.348-.861-4.533.838-5.688 2.725-10.253 2.41-8.206-.564-9.218-4.512-7.181-8.747.884-1.837 2.374-3.308 4.199-4.215 3.557-1.77 7.423-2.488 12.894-1.913 4.481.467 20.431 6.583 11.689 13.328z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M385.346 225.464q0 3.51-.139 6.985c-2.517 63.919-39.452 118.993-92.787 147.205-24.295 12.852-51.995 20.13-81.393 20.13-77.898 0-143.86-51.097-166.205-121.599 27.025 52.831 81.991 88.993 145.408 88.993 30.968 0 59.922-8.624 84.592-23.603-3.824-13.307-5.754-28.072-5.754-44.104v-38.88l2.433-3.001c.661-.819 6.833-8.193 19.545-15.414 7.332-4.165 15.439-7.477 24.093-9.843 10.714-2.927 22.32-4.413 34.497-4.413q1.037 0 2.067.015a164.5 164.5 0 0 0 1.751-23.979c0-61.472-33.984-115.01-84.19-142.846 67.638 23.966 116.082 88.502 116.082 164.354",
  opacity: 0.11
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__i)",
  d: "M348.314 411.641c-.789-.129-19.553-3.328-38.178-18.95-10.878-9.123-19.53-20.624-25.718-34.182-7.587-16.621-11.434-36.352-11.434-58.641v-37.309l1.836-2.267c.932-1.153 23.448-28.222 74.818-28.222s74.15 27.315 75.019 28.479l1.635 2.191v37.128c0 22.289-3.847 42.02-11.434 58.641-6.187 13.558-14.841 25.057-25.717 34.182-18.626 15.622-37.39 18.821-38.179 18.95l-1.322.214-1.321-.214z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__j)",
  d: "M349.636 233.996c11.975 0 23.251 1.418 33.515 4.217 8.235 2.246 15.85 5.384 22.632 9.326 11.801 6.856 17.11 13.867 17.331 14.163l1.255 1.68v36.488c0 22.012-3.788 41.473-11.262 57.844-6.067 13.294-14.548 24.568-25.206 33.506-18.229 15.29-36.484 18.4-37.252 18.524l-1.015.165-1.014-.165c-.768-.124-19.023-3.234-37.253-18.524-10.657-8.938-19.136-20.212-25.206-33.506-7.471-16.369-11.261-35.832-11.261-57.844v-36.629l1.408-1.739c.237-.294 5.964-7.273 17.951-14.081 6.882-3.91 14.503-7.021 22.649-9.248 10.147-2.773 21.155-4.179 32.724-4.179m.004-1.919c-51.37 0-73.884 27.068-74.818 28.221l-1.836 2.267v37.309c0 22.29 3.848 42.02 11.434 58.642 6.188 13.557 14.842 25.056 25.718 34.182 18.625 15.622 37.389 18.82 38.179 18.949l1.321.215 1.322-.215c.789-.129 19.553-3.327 38.178-18.949 10.879-9.124 19.531-20.625 25.718-34.182 7.587-16.622 11.434-36.352 11.434-58.642v-37.128l-1.635-2.191c-.867-1.164-21.873-28.478-75.019-28.478z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__k)",
  d: "M418.057 265.478v34.392c0 92.51-68.421 103.645-68.421 103.645s-68.421-11.133-68.421-103.645v-34.392s20.387-25.171 68.421-25.171 68.421 25.171 68.421 25.171"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__l)",
  d: "M349.636 243.054c10.983 0 21.304 1.269 30.673 3.773 7.474 1.998 14.364 4.782 20.48 8.273 8.395 4.795 13.025 9.641 14.523 11.365v33.407c0 20.623-3.485 38.758-10.36 53.902-5.468 12.044-13.089 22.247-22.65 30.324-8.525 7.202-17.061 11.359-22.72 13.577-5.009 1.963-8.715 2.799-9.944 3.047-1.233-.248-4.937-1.084-9.944-3.047-5.659-2.218-14.195-6.375-22.721-13.577-9.561-8.077-17.181-18.28-22.649-30.324-6.875-15.144-10.361-33.279-10.361-53.902v-33.35c1.636-1.758 6.548-6.6 15.073-11.39 6.236-3.504 13.16-6.295 20.578-8.298 9.29-2.509 19.392-3.78 30.026-3.78m-.004-2.747c-48.034 0-68.421 25.171-68.421 25.171v34.392c0 92.51 68.421 103.645 68.421 103.645s68.421-11.133 68.421-103.645v-34.392s-18.792-25.171-68.421-25.171"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__m)",
  d: "M349.637 240.308c49.629 0 68.421 25.17 68.421 25.17v34.392c0 92.51-68.421 103.645-68.421 103.645s-68.421-11.133-68.421-103.645v-34.392s20.386-25.17 68.421-25.17m0-1.373c-11.079 0-21.614 1.339-31.316 3.982-7.778 2.117-15.039 5.072-21.584 8.782-11.198 6.348-16.371 12.651-16.586 12.916l-.305.377v34.878c0 21.3 3.638 40.071 10.815 55.792 5.76 12.621 13.797 23.31 23.887 31.772 8.98 7.532 17.956 11.866 23.905 14.174 6.474 2.513 10.786 3.231 10.967 3.26l.221.036.221-.036c.181-.029 4.493-.747 10.967-3.26 5.949-2.308 14.925-6.642 23.905-14.174 10.089-8.462 18.127-19.151 23.887-31.772 7.176-15.721 10.815-34.494 10.815-55.792v-34.849l-.274-.366c-.197-.265-4.994-6.591-16.013-12.951-6.432-3.713-13.673-6.67-21.521-8.789-9.784-2.641-20.545-3.98-31.985-3.98z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#glob_svg__n)",
  d: "M358.871 323.957v12.861a9.234 9.234 0 0 1-9.235 9.234 9.2 9.2 0 0 1-6.528-2.706 9.2 9.2 0 0 1-2.707-6.528v-12.861c-6.132-3.294-10.303-9.772-10.303-17.22 0-10.983 9.07-19.856 20.13-19.528 10.116.299 18.435 8.461 18.922 18.569.378 7.848-3.888 14.746-10.281 18.181z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m355.719 247.419-67.203 67.202q-.552-6.22-.606-12.817l54.302-54.301c2.386-.145 4.859-.223 7.42-.223q3.134 0 6.084.141zM411.363 268.586v19.857l-92.255 92.255c-9.018-7.674-16.203-17.361-21.365-28.793-2.938-6.513-5.226-13.61-6.85-21.249l81.309-81.309c11.581 2.239 20.147 5.936 25.98 9.23 7.078 3.997 11.333 8.035 13.179 10.011zM411.252 306.46c-.488 13.538-2.605 25.858-6.328 36.798l-52.527 52.527c-1.198.345-2.141.57-2.766.711-2.603-.58-10.672-2.7-20.092-8.325l81.711-81.711z",
  opacity: 0.12
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(177.331 157.633)scale(228.349)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#06B6D4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#083344"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(178.266 148.488)scale(245.729)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10B981"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(178.265 148.488)scale(245.729)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10B981"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__d",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(178.266 148.488)scale(245.729)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#10A681"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(.105 148.488)scale(245.729)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10B981"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(178.265 148.488)scale(245.729)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10B981"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(178.266 148.488)scale(245.729)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10B981"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "glob_svg__h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(245.724 0 0 245.725 .105 148.488)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6EE7B7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10B981"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glob_svg__i",
  x1: 285.481,
  x2: 405.952,
  y1: 264.299,
  y2: 354.654,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DBDBDB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C9D8DB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glob_svg__j",
  x1: 276.649,
  x2: 415.401,
  y1: 257.674,
  y2: 361.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C7C7C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0C2C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glob_svg__k",
  x1: 310.26,
  x2: 402.188,
  y1: 267.896,
  y2: 362.714,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#22D3EE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0C4A6E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glob_svg__l",
  x1: 310.26,
  x2: 402.188,
  y1: 267.896,
  y2: 362.714,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0E7490"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#082F49"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glob_svg__m",
  x1: 282.211,
  x2: 409.915,
  y1: 261.837,
  y2: 357.615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C7C7C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0C2C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "glob_svg__n",
  x1: 337.093,
  x2: 366.287,
  y1: 301.457,
  y2: 331.571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#05244A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#03061A"
})))));
export default SvgGlob;